/*
 * Copyright (c) 2024 SmartWifi - All Rights Reserved.
 *
 * Unauthorized copying of this file, via any medium is strictly prohibited.
 * Proprietary and confidential. No warranty, explicit or implicit provided. In
 * no event will the author be liable for any claim or damages.
 */

export const server = "production";
export const region = "US";
export const urlBase = "https://dashboard.smartwifi.ai";
export const radiusEndpointBase = "https://radius.smartwifi.ai:8080/";
export const remoteManagerEndpointBase = "https://remotemanager.smartwifi.ai:8080/";
export const smartWiFiExternalBase = "https://smartwifi.ai/";

export const s3Base = "https://smartwifi-bucket.s3.us-east-2.amazonaws.com/";

export const paypalClientId = "Adx2Vz4SCNTlIdnVVPzxndbkhGc5f-y8t45f3x8qzicLuDx0qOwrGDYOK2bWcDDfrr-hvX8wGd-puyzf";

export const smsService = "twilio";

export const billingPortalUrl = "https://billing.stripe.com/p/login/9AQ5mV1sseYc4Jq3cc";